import { Pipe, PipeTransform } from '@angular/core';
import { Roles } from 'src/app/core/models/role.model';

@Pipe({
  name: 'role'
})
export class RolePipe implements PipeTransform {

  transform(value: any): any {
    switch (value) {
      case Roles.Marketer: return 'بازاریاب';
      case Roles.SalesManager: return 'مدیرفروش';
      case Roles.SalesRepresentative: return 'نماینده فروش';
      default: return 'نامشخص';
    }
  }

}
